const getTimeDuration = (value, f) =>
  f.getDateTime({ date: value }).diffNow(['minutes', 'hours']);

export default getTimeDuration;
